import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWarehouse,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";

const WarehouseTab = ({ item }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex flex-col items-center justify-center py-10">
        <FontAwesomeIcon
          icon={faWarehouse}
          className="text-gray-400 text-5xl mb-4"
        />
        <p className="text-gray-700 mb-2 font-medium text-lg">
          Warehouse Data Not Available
        </p>
        <p className="text-gray-500 text-center max-w-md">
          Warehouse information for this shipment is not available at the
          moment. This feature will be available in a future update.
        </p>
      </div>
    </div>
  );
};

export default WarehouseTab;
